import { Form } from 'formik';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import BaseField from 'components/Field';

export const Wrapper = styled.div`
  @media ${({ theme }) => theme.device.mobile} {
    height: 100vh;
  }
`;

export const FormContainer = styled(Form)`
  overflow-x: hidden;

  @media ${({ theme }) => theme.device.mobile} {
    padding-bottom: 100px;
  }
`;

export const Container = styled.section`
  height: auto;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${ColorPalette.HEX.Lotion};
    min-height: 100vh;
  }
`;

export const Content = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }
`;

export const Line = styled.div`
  width: 100%;
  margin-bottom: 32px;
  height: 1px;
  border-bottom: solid 1px ${ColorPalette.HEX.BrightGray};

  @media ${({ theme }) => theme.device.mobile} {
    margin-left: -16px;
    width: calc(100% + 32px);
  }
`;

export const Field = styled(BaseField)`
  margin-bottom: 16px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  margin-top: 32px;

  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;
